export default "__VITE_ASSET__44fb2974__"